import {
    collection,
    FirestoreDataConverter,
    QueryDocumentSnapshot,
} from "firebase/firestore";

import { db } from "./app.firebase";

/** Raw shape of a location document as stored in Firestore. */
export type LocationDoc = {
    id: string;
    description: string;
    /** Array of image URLs stored under the `imgsUrls` field. */
    imgsUrls: string[];
    /** Firestore GeoPoint — exposes `.latitude` and `.longitude`. */
    coords: { latitude: number; longitude: number };
    coordsHash: string;
};

const locationConverter: FirestoreDataConverter<LocationDoc> = {
    toFirestore: (doc) => doc,
    fromFirestore: (snapshot: QueryDocumentSnapshot) => {
        const d = snapshot.data();
        return {
            id: d["id"] ?? snapshot.id,
            description: d["description"] ?? "",
            imgsUrls: d["imgsUrls"] ?? [],
            coords: d["coords"] ?? { latitude: 0, longitude: 0 },
            coordsHash: d["coordsHash"] ?? "",
        };
    },
};

// Note: Firestore collection name remains "shelters" for backward compatibility with existing data
export const locationsCollection = collection(db, "shelters").withConverter(
    locationConverter
);
